const input = document.getElementById('input-name');
const button = document.getElementById('submit-name');

const changeButtonState = () => {
  const localStorageItem = localStorage.getItem('app-name');
  button.disabled = input.value === localStorageItem;
};

const setInputInitValue = () => {
  const localStorageItem = localStorage.getItem('app-name') || '';
  input.value = (localStorageItem.toString().length > 0 ) ? localStorageItem : '';
};

const onButtonClick = () => {
  localStorage.setItem('app-name', input.value);
  changeButtonState();
};

const onInputChange = () => {
  changeButtonState();
};

if (input && button) {
  setInputInitValue();
  changeButtonState();
  input.addEventListener('keyup', onInputChange);
  button.addEventListener('click', onButtonClick);
}
